import { usePopover } from "../../lib/usePopover.js"
import styles from "./RowActionMenu.module.css"

interface Props {
  onBulkRegister: () => void
  onDelete: () => void
  deleteLabel?: string
  ariaLabel?: string
}

export function RowActionMenu({
  onBulkRegister,
  onDelete,
  deleteLabel = "削除",
  ariaLabel = "操作",
}: Props) {
  const { open, setOpen, rootRef } = usePopover<HTMLDivElement>()

  return (
    <div className={styles.wrapper} ref={rootRef}>
      <button
        type="button"
        className={styles.menuBtn}
        aria-label={ariaLabel}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        ⋯
      </button>
      {open && (
        <div className={styles.menuDropdown} role="menu">
          <button
            type="button"
            className={styles.menuItem}
            role="menuitem"
            onClick={() => {
              setOpen(false)
              onBulkRegister()
            }}
          >
            一括銘柄登録
          </button>
          <button
            type="button"
            className={`${styles.menuItem} ${styles.menuItemDanger}`}
            role="menuitem"
            onClick={() => {
              setOpen(false)
              onDelete()
            }}
          >
            {deleteLabel}
          </button>
        </div>
      )}
    </div>
  )
}
